// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli?q=&limit=20&societaId=&tipologia=',
    requestBody: null,
    response: '{"data":[{"id":"number","codice":"string","descrizioneBase":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-intercambiabili/template',
    requestBody: null,
    response: 'file xlsx'
  },
  {
    method: 'POST',
    endpoint: '/api/articoli-intercambiabili/import',
    requestBody: '(multipart: file, societaId)',
    response: '{"success":"true","data":{"stato":"string","totaleRighe":"number","padreCreati":"number","padreRiusati":"number","gruppiAggiornati":"number","righeErrore":"number","logTesto":"string","fatalError":"string|null"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/categorie-merceologiche?pageSize=200&societaId=',
    requestBody: null,
    response: '{"data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/valori-ammessi?societaId=N',
    requestBody: null,
    response: '{"success":true,"data":"ValoriAmmessi"}'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-intercambiabili?page=1&pageSize=20&societaId=&search=&categoriaMerceologicaId=',
    requestBody: null,
    response: '{"success":"true","data":[{"articoloPadreId":"number","codicePadre":"string","descrizionePadre":"string","nFigli":"number"}],"total":"number"}'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-intercambiabili/:padreId?societaId=',
    requestBody: null,
    response: '{"success":"true","data":{"articoloPadre":{"id":"number","codice":"string"},"figli":[{"id":"number","codice":"string"}]}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/articoli-intercambiabili/:padreId',
    requestBody: '{"figli":[1,2,3],"societaId":"optional"}',
    response: '{"success":"true","data":{"articoloPadreId":"number","nFigli":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/articoli-intercambiabili',
    requestBody: '{"societaId":"number","articoloPadreId":"number","figli":[1,2,3]}',
    response: '{"success":"true","data":{"articoloPadreId":"number","nFigliCreati":"number"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/articoli-intercambiabili/:padreId?societaId=',
    requestBody: null,
    response: '{"success":"true","data":{"deleted":"number"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
